module.exports = __webpack_public_path__ + "static/media/logo-fundacred-branco.b6e086ad.svg";